import axios from 'axios';
import React, { useState } from 'react';
import { BsCheck2Circle, BsXLg } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../config/axiosInstance';
import { globalEnv } from '../../../config/baseConfig';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import LoadingCircles from '../../Utils/LoadingAnimations/LoadingCircles';
import placeholder from '../../../assets/images/placeholder.png';

type topicType = {
	topicId: string;
	dashboardId: string;
	image: any;
	name: string;
	singleTopic: boolean;

	topicsList: any[];
	setTopics: (topics: any[]) => void;
};

export function TopicCard(props: topicType) {
	const navigate = useNavigate();

	const [isDeleting, setIsDeleting] = useState(false);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const [random, setRandom] = useState(Math.floor(Math.random() * 101));

	interface IUnsubscribeFromTopic {
		dashboardId: string;
		topicId: string;
	}

	const removeTopicReq = async (data: IUnsubscribeFromTopic) => {
		const dto = {
			dashboardId: data.dashboardId,
			topics: [data.topicId].map((topic) => topic)
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + '/dashboard/remove-topic',
			dto,
			config
		);
		return response;
	};

	const { mutate } = useMutation(removeTopicReq, {
		onSuccess: () => {
			props.setTopics(
				props.topicsList.filter((topic) => topic._id != props.topicId)
			);
			setIsDeleting(false);
		},
		onError: () => {
			setIsDeleting(false);
		}
	});

	const removeTopicFromDash = (dashboardId: string, topicId: string) => {
		setIsDeleting(true);
		mutate({ dashboardId, topicId });
	};

	return (
		<div className="carousel-item flex flex-col transition-all duration-700">
			<div className="relative mx-3 overflow-hidden shadow-xl rounded-2xl max-w-xl ">
				<img
					src={
						props.image != null && props.image.url_low_res != null
							? props.image.url_low_res
							: placeholder
					}
					className="rounded-box object-cover h-44 w-64"
				/>

				{isDeleting && (
					<div className="absolute inset-0 z-50 h-full w-full">
						<div className="bg-black w-full h-full z-40 opacity-70"></div>
						<div className="absolute top-1/2 left-0 w-full h-full">
							<LoadingCircles />
						</div>
					</div>
				)}

				<div
					className="absolute inset-0 bg-gradient-to-t from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center  cursor-pointer"
					onClick={() => navigate(`../topic/${props.topicId}`)}
				>
					<div className="group">
						<button
							className="absolute top-2 left-2 btn-error btn-xs btn btn-circle btn-outline shadow-md"
							onClick={(e) => {
								if (!props.singleTopic) {
									e.stopPropagation();
									removeTopicFromDash(props.dashboardId, props.topicId);
								}
							}}
						>
							<BsXLg />
						</button>
						<span
							className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
									  scale-0 origin-left group-hover:scale-100
						              font-bold transition-all duration-500 opacity-0 group-hover:opacity-100 top-1 left-10"
						>
							{props.singleTopic ? "Can't remove 🚫" : 'Remove ❌'}
						</span>
					</div>
				</div>
			</div>

			<h3 className="text-gray-600 dark:text-gray-200 text-lg mt-2 font-semibold">
				{props.name}
			</h3>
		</div>
	);
}

type selectibleTopicType = {
	id: string;
	image: string;
	name: string;

	addedTopics: any[];
	setAddedTopics: (item: any) => void;
};

export function SelectibleTopicCard(props: selectibleTopicType) {
	const [isSelected, setSelected] = useState(false);

	const updateSelected = () => {
		if (!isSelected) props.setAddedTopics([...props.addedTopics, props.id]);
		else {
			props.setAddedTopics(
				props.addedTopics.filter((item) => item._id !== props.id)
			);
		}
		setSelected(!isSelected);
	};

	return (
		<div
			className="carousel-item flex flex-col"
			onClick={() => updateSelected()}
		>
			<div className="relative p-2 justify-center content-center mx-3 rounded-xl">
				<img src={props.image} className="rounded-box object-cover h-44 w-64" />

				<div
					className={
						isSelected
							? 'absolute inset-0 m-2 bg-gradient-to-t rounded-lg from-black/75 opacity-100 text-center transition-colors duration-500'
							: 'absolute inset-0 m-2 bg-gradient-to-t rounded-lg from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center'
					}
				></div>
				{isSelected ? (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-gray-100 dark:shadow-lg dark:text-primary text-center transition-all duration-500 opacity-100"
					/>
				) : (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-gray-100 dark:shadow-lg mx-2 dark:text-primary text-center transition-all duration-500 opacity-0 scale-0"
					/>
				)}
			</div>

			<h3 className="text-gray-600 dark:text-gray-200 text-lg mt-2 font-semibold">
				{props.name}
			</h3>
		</div>
	);
}
